import type { CommunicationFormValues } from "./api";

export const MINUTE_PARTICIPANTS = ["Contratista", "Residencia", "Supervisión", "Otro"] as const;
const isPreset = (value: string) => value === "Contratista" || value === "Residencia" || value === "Supervisión";

export function minuteParticipantSelection(participants: string[]) {
  const custom = participants.filter((value) => !isPreset(value));
  return {
    choices: [...participants.filter(isPreset), ...(custom.length ? ["Otro"] : [])],
    custom: custom.join("; "),
  };
}

export function communicationDisplayTitle(row: { titulo?: unknown; resumen?: unknown }) {
  return (typeof row.titulo === "string" ? row.titulo.trim() : "") || String(row.resumen || "—");
}

export function isMinuteDocument(name: unknown) {
  return String(name || "").trim().toLocaleLowerCase("es") === "minuta";
}

export function prepareCommunicationValues(values: CommunicationFormValues, isMinute: boolean, choices: string[], custom: string): CommunicationFormValues {
  const needsAuthor = isMinute && values.emisor.trim() === "Supervisión";
  return {
    ...values,
    puntos: isMinute ? values.puntos : [],
    destinatarios: isMinute ? [] : values.destinatarios.map(({ fecha_vencimiento: _due, atendido: _attended, nombre: _name, ...recipient }) => ({ ...recipient, nombre_otro: recipient.tipo_destinatario === "Otro" ? recipient.nombre_otro?.trim() || null : null })),
    requiere_respuesta: !isMinute && values.requiere_respuesta,
    dias_contestacion: !isMinute && values.requiere_respuesta ? values.dias_contestacion : null,
    titulo: values.titulo.trim(),
    emisor: values.emisor.trim(),
    destinatario: isMinute ? null : values.destinatario?.trim() || null,
    autor_user_id: needsAuthor ? values.autor_user_id : null,
    autor_nombre: needsAuthor ? values.autor_nombre : null,
    participantes: isMinute ? [
      ...choices.filter(isPreset),
      ...(choices.includes("Otro") ? custom.split(";").map((name) => name.trim()).filter(Boolean) : []),
    ] : [],
  };
}
